export default {
  isBusy: true,
};
